import { type ZodType } from "zod";

export const zodUnsafeValidate = <T>(schema: ZodType<T>, data: T): T => {
  try {
    return schema.parse(data);
  } catch (error) {
    console.error(error);

    return data;
  }
};
